import React from "react";
import styled from "@emotion/styled";
import {carsTheme} from "@rw/themes";

interface IFilterFieldClearProps {
    visible: boolean;
    label: string;
    onClear: () => void;
}

export const FilterFieldClear: React.FC<IFilterFieldClearProps> = ({visible, label, onClear}) => {
    if (!visible) {
        return null;
    }
    return (
        <ClearFieldButton
            type="button"
            aria-label={label}
            title={label}
            onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                onClear();
            }}
        >
            ×
        </ClearFieldButton>
    );
};

export const InputWrap = styled.div`
    position: relative;
    width: 100%;

    &[data-clearable="1"] > select,
    &[data-clearable="1"] > input {
        padding-right: 34px;
    }
`;

const ClearFieldButton = styled.button`
    position: absolute;
    top: 50%;
    right: 6px;
    z-index: 2;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    margin: 0;
    padding: 0;
    border: 0;
    border-radius: 50%;
    background: transparent;
    color: ${carsTheme.colors.gray};
    font-size: 18px;
    line-height: 1;
    cursor: pointer;
    transform: translateY(-50%);

    &:hover {
        color: ${carsTheme.colors.brand_black};
        background: rgba(0, 0, 0, 0.06);
    }
`;
